<template>
  <div class="space-y-1">
    <!-- Keystroke / window / clipboard events -->
    <div
      v-for="(event, idx) in events"
      :key="idx"
      :class="{ 'mt-2': idx > 0 && isSeparator(event), 'w-fit': true }"
    >
      <!-- Window focus / title change: filled chip (theme-adaptive) -->
      <div
        v-if="event.type === 'window'"
        class="bg-primary text-primary-content inline-flex items-center gap-1.5 rounded px-2 py-0.5 text-sm font-medium"
      >
        <i class="fa-solid fa-window-maximize"></i>
        <span class="max-w-120 truncate">{{ event.title }}</span>
      </div>

      <!-- Clipboard snapshot / config: dark code card (theme-adaptive) -->
      <div
        v-else-if="event.type === 'clipboard'"
        class="group bg-primary flex items-start gap-2 rounded p-2"
      >
        <i class="fa-solid fa-clipboard text-primary-content/70 mt-0.5"></i>
        <pre
          class="text-primary-content min-w-0 grow overflow-x-auto font-mono text-xs leading-relaxed break-all whitespace-pre-wrap opacity-95"
          >{{ clipText(event.raw) }}</pre>
        <button
          type="button"
          class="btn btn-xs btn-ghost hover:bg-primary-content/15 -mt-0.5 -mr-1 shrink-0 rounded opacity-0 transition group-hover:opacity-100"
          title="Sao chép"
          @click="copyClipboard(event.raw)"
        >
          <i class="fa-solid fa-copy"></i>
        </button>
      </div>

      <!-- Raw keystrokes: dark mono text on transparent bg -->
      <div
        v-else
        class="text-base-content inline-block font-mono text-sm leading-relaxed break-all whitespace-pre-wrap"
      >
        {{ event.text }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { toast } from "vue3-toastify";
import type { KeylogEvent } from "./parseKeylog";

const props = defineProps<{
  events: KeylogEvent[];
}>();

/** A separator gap should precede a new window event. */
function isSeparator(event: KeylogEvent): boolean {
  return event.type === "window";
}

/** Best-effort pretty JSON, falling back to the raw string. */
function clipText(raw: string): string {
  try {
    return JSON.stringify(JSON.parse(raw), null, 2);
  } catch {
    return raw;
  }
}

async function copyClipboard(raw: string): Promise<void> {
  try {
    await navigator.clipboard.writeText(clipText(raw));
    toast.success("Đã sao chép clipboard!");
  } catch (error) {
    console.error("Error copying clipboard:", error);
    toast.error("Không thể sao chép!");
  }
}
</script>
